/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { MdOutlinePermPhoneMsg } from "react-icons/md";
import { TbFileDownload } from "react-icons/tb";
import moment from "moment-timezone";
import { Data, useOperadorCaixa } from "../../../../../context/OperadorCaixaContext";
import { Loader } from "../../../../generics/loader";
import { formatMoney } from "../../../../../utils/formatMoney";
import { useDividas } from "../../../../../context/DividasContext";
import { useModal } from "../../../../../hooks/ModalContext";
import Search from "../../../../../assets/icons/search.svg";
import { IoMdClose } from "react-icons/io";
import ExcelJS from "exceljs";
import { Spinner } from "../../../../../components/Spinner";
import { formatCPFCNPJ } from "../../../../../utils/formatCPFCNPJ";
import { errorAlert } from "../../../../../components/Alerts/Error";
import { ChevronDown, ChevronUp } from "lucide-react";
import { isAfter, isToday } from "date-fns";


// import { format } from 'date-fns'


interface TabelaCobrancaProps {
  data: Data | null;
  loading: boolean;
  handleOpenTab: (value: string) => void;
}

export default function TabelaCobranca({
  data,
  loading,
  handleOpenTab,
}: TabelaCobrancaProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const { setModal } = useModal();
  const [nameCliente, setNameCliente] = useState("");
  const [filterName, setFilterName] = useState("");

  const [ordem, setOrdem] = useState('')
  const { getDividasGazin, devedor, clearDividas } = useDividas();
  const { loadData, filtros, page, setPage } = useOperadorCaixa();

  const [tabelaData, setTabelaData] = useState(data?.data.map((dat) => ({
    ...dat,
    valor_vencido: dat.valor_vencido ? formatMoney(dat.valor_vencido) : "-",
    data_ultimo_acionamento: dat.data_ultimo_acionamento
      ? moment(new Date(dat.data_ultimo_acionamento))
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY")
      : "-",
    data_agendamento: dat.data_agendamento
      ? moment(new Date(dat.data_agendamento))
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY")
      : "-",
    button: <MdOutlinePermPhoneMsg />,
  })))

  const newData = data?.data.map((dat) => ({
    ...dat,
    valor_vencido: dat.valor_vencido ? formatMoney(dat.valor_vencido) : "-",
    data_ultimo_acionamento: dat.data_ultimo_acionamento
      ? moment(new Date(dat.data_ultimo_acionamento))
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY")
      : "-",
    data_agendamento: dat.data_agendamento
      ? moment(new Date(dat.data_agendamento))
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY")
      : "-",
    button: <MdOutlinePermPhoneMsg />,
  }))

  function handleSearch() {
    setFilterName(nameCliente);
  }
  function handleClearSearch() {
    setFilterName("");
    setNameCliente("");
  }

  async function downloadCSV() {
    const rightAlign = [6, 7];
    setIsLoading(true);
    let arrayData: Data | undefined;
    try {
      arrayData = await loadData({
        ...filtros,
        page: 0,
      });
    } catch (error) {
      errorAlert();
      setIsLoading(false);
    }
    if (!arrayData) {
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Relatório Completo");
    const header = sheet.addRow([
      "Data Lista",
      "Assessoria",
      "Id Loja",
      "Vendedor",
      "Atraso",
      "Valor Vencido",
      "Valor a Vencer",
      "Ultimo Acionamento",
      "Data Agendamento",
      "Id Processo",
      "CPF/CNPJ Cliente",
      "Cliente",
      "Telefone Móvel 1",
      "Telefone Móvel 2",
      "Telefone Móvel 3",
      "Telefone Móvel 4",
      "Telefone Móvel 5",
      "Telefone Móvel Ref 1",
      "Telefone Móvel Ref 2",
      "Telefone Móvel Ref 3",
      "Email",
    ]);
    header.eachCell((cell) => {
      cell.style = {
        font: {
          bold: true,
        },
      };
    });

    for (const item of arrayData.data) {
      sheet.addRow([
        item?.data_lista
          ? moment(new Date(item.data_lista))
            .tz("America/Sao_Paulo")
            .format("DD/MM/YYYY")
          : "",

        item.assessoria ?? "",
        item.loja ?? "",
        item.nome_vendedor,
        item.atraso ?? "",
        formatMoney(item.valor_vencido ?? 0),
        formatMoney(item.valor_a_vencer ?? 0),
        item.data_ultimo_acionamento
          ? moment(new Date(item.data_ultimo_acionamento))
            .tz("America/Sao_Paulo")
            .format("DD/MM/YYYY")
          : "",
        item.data_agendamento
          ? moment(new Date(item.data_agendamento))
            .tz("America/Sao_Paulo")
            .format("DD/MM/YYYY")
          : "",
        item.id_processo ?? "",
        item.cpf_cnpj ? formatCPFCNPJ(item.cpf_cnpj) : "",
        item.nome_cliente ?? "",
        item?.fone1 ?? "",
        item?.fone2 ?? "",
        item?.fone3 ?? "",
        item?.fone4 ?? "",
        item?.fone5 ?? "",
        item?.fone6 ?? "",
        item?.fone7 ?? "",
        item?.fone8 ?? "",
        item?.email ?? "",
      ]);
    }
    sheet.eachRow((row) => {
      row.eachCell((cell, col) => {
        if (rightAlign.includes(col)) {
          cell.alignment = { horizontal: "right" };
        } else {
          cell.alignment = { horizontal: "left" };
        }
      });
    });
    sheet.columns.forEach((column) => {
      const lengths = column?.values?.map((v) => (v ?? 0).toString().length);
      const maxLength = Math.max(
        ...(lengths ?? []).filter((v) => typeof v === "number")
      );

      column.width = maxLength + 5;
      column?.eachCell &&
        column.eachCell((cell) => {
          cell.font = {
            ...cell.font,
            name: "Calibri",
          };
        });
    });

    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const date = new Date().getDate();
        link.setAttribute("download", `Relatório dia ${date}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error generating Excel file:", error);
        errorAlert();
      })
      .finally(() => setIsLoading(false));
  }
  const handleNextPage = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (page > 1) {
      setPage((prevPage) => prevPage - 1);
    }
  };

  async function handleDoubleClick(cpf_cnpj: string, id: number) {
    setSpinner(true);
    try {
      clearDividas()
      handleOpenTab("atendimento");
      await getDividasGazin({ cpf_cnpj, id, app: 'ACIONA_CXA' });

    } catch (err) {
      setModal(
        "Falha ao selecionar  o cliente! Tente novamente mais tarde",
        "Erro",
        false,
        true
      );
      console.log("esse erro aqui", err);
    } finally {
      setSpinner(false);
    }
  }

  const converterData = (data: string) => {
    const [dia, mes, ano] = data.split('/');
    return new Date(parseInt(ano, 10), parseInt(mes, 10) - 1, parseInt(dia, 10));
  };


  const converterValor = (valor: string) => {
    return parseFloat(valor.replace('R$', '').replace('.', '').replace(',', '.').trim());
  };

  function ordenacao(tag: string, sentido: string, isPaginacao?: boolean) {
    if (`${tag} ${sentido}` === ordem && !isPaginacao) {
      setOrdem('')
      setTabelaData(newData)
      return
    } else {
      setOrdem(`${tag} ${sentido}`)
      if (tag === 'Atraso') {
        if (sentido === 'Crescente') {
          setTabelaData(newData?.sort((a, b) => a.atraso - b.atraso))
          return
        }
        setTabelaData(newData?.sort((a, b) => b.atraso - a.atraso))
        return
      }

      if (tag === 'Valor') {
        if (sentido === 'Crescente') {
          setTabelaData(newData?.sort((a, b) => converterValor(a.valor_vencido) - converterValor(b.valor_vencido)))

          return
        }
        return setTabelaData(newData?.sort((a, b) => converterValor(b.valor_vencido) - converterValor(a.valor_vencido)));
      }

      if (tag === 'Acionamento') {
        if (sentido === 'Crescente') {
          return setTabelaData(newData?.sort((a, b) => converterData(a.data_ultimo_acionamento).getTime() - converterData(b.data_ultimo_acionamento).getTime()));

        }

        return setTabelaData(newData?.sort((a, b) => converterData(b.data_ultimo_acionamento).getTime() - converterData(a.data_ultimo_acionamento).getTime()));
      }

      if (tag === 'Agendamento') {
        if (sentido === 'Crescente') {
          return setTabelaData(newData?.sort((a, b) => converterData(a.data_agendamento).getTime() - converterData(b.data_agendamento).getTime()));
        }
        return setTabelaData(newData?.sort((a, b) => converterData(b.data_agendamento).getTime() - converterData(a.data_agendamento).getTime()));
      }

      if (tag === 'Nome Vendedor') {
        if (sentido === 'Crescente') {
          return setTabelaData(newData?.sort((a, b) => a.nome_vendedor.localeCompare(b.nome_vendedor)))
        }
        return setTabelaData(newData?.sort((a, b) => b.nome_vendedor.localeCompare(a.nome_vendedor)))
      }

      if (tag === 'Nome Cliente') {
        if (sentido === 'Crescente') {
          return setTabelaData(newData?.sort((a, b) => a.nome_cliente.localeCompare(b.nome_cliente)))
        }
        return setTabelaData(newData?.sort((a, b) => b.nome_cliente.localeCompare(a.nome_cliente)))
      }

      if (tag === 'Processos') {
        if (sentido === 'Crescente') {
          return setTabelaData(newData?.sort((a, b) => Number(a.id_processo) - Number(b.id_processo)))

        }
        return setTabelaData(newData?.sort((a, b) => Number(b.id_processo) - Number(a.id_processo)));
      }
    }


  }

  useEffect(() => {
    loadData({
      ...filtros,
      page: page,

    });
  }, [page]);

  useEffect(() => {
    if (ordem !== '') {
      const [tag, sentido] = ordem.split(' ')
      ordenacao(tag, sentido, true)
    } else {
      setTabelaData(newData)
    }
  }, [data])

  function formatDate(date?: string) {
    if (date && date !== '-') {
      const [dia, mes, ano] = date.split('/')
      return `${mes}/${dia}/${ano}`
    }
    return '-'
  }

  return (
    <div className="flex h-[100vh] w-[100%] items-center justify-center overflow-y-hidden pb-10">
      {!data || loading || spinner ? (
        <div className="flex h-[20rem] w-full items-center justify-center">
          <Loader />
        </div>
      ) : (
        <>
          {data.data.length < 1 ? (
            <div className="w-full p-10 text-center">
              <p className="text-2xl font-bold text-coolGray-700">
                Não existe fila para esta seleção, verifique os filtros ou o
                operador.
              </p>
            </div>
          ) : (
            <div className="mt-[1rem] flex h-[100%] w-full flex-col justify-between">
              <div className="relative h-full  w-full overflow-y-auto">
                <div className="my-2 flex items-center justify-between space-x-2 z-1 sticky top-0 bg-white">
                  <div className="flex w-[50%] items-center ">
                    <input
                      className="rounded border p-1"
                      type="text"
                      placeholder="Digite o nome do cliente..."
                      value={nameCliente}
                      onChange={(e) => setNameCliente(e.target.value)}
                    />
                    <button
                      className="mx-1 rounded-lg bg-primary p-1 font-bold text-white"
                      onClick={handleSearch}
                    >
                      <img src={Search} alt="search icon" />
                    </button>
                    <button
                      className="rounded-lg bg-coolGray-200 p-2 font-bold text-primary"
                      onClick={handleClearSearch}
                    >
                      <IoMdClose />
                    </button>
                  </div>
                  <div className="flex items-center p-2">
                    {isLoading ? (
                      <div className="mr-8">
                        <Spinner />
                      </div>
                    ) : (
                      <>
                        <button
                          className="font-bold text-primary"
                          onClick={downloadCSV}
                        >
                          <p>Baixar relatório completo</p>
                        </button>
                        <TbFileDownload size={32} color="primary" />
                      </>
                    )}
                  </div>
                </div>
                <table className="h-full border-collapse">
                  <thead className="z-1 sticky top-10 h-[3rem] bg-slate-100">
                    <tr>
                      <th className="w-[10%] border p-2 text-left">CPF</th>
                      <th className="w-[20%] border p-2 text-left">

                        <div className="flex items-center justify-between">
                          <p>Nome cliente</p>
                          <div className="flex flex-col ">
                            <button className={`${ordem === 'Nome Cliente Crescente' && "border rounded-md border-primary"} `} onClick={() => ordenacao('Nome Cliente', 'Crescente')}><ChevronUp size={16} /></button>

                            <button className={`${ordem === 'Nome Cliente Decrescente' && "border rounded-md border-primary"}`} onClick={() => ordenacao('Nome Cliente', 'Decrescente')}><ChevronDown size={16} /></button>
                          </div>
                        </div>
                      </th>
                      <th className="w-[5%] border p-2 text-left">

                        <div className="flex items-center justify-between">
                          <p>Processo</p>
                          <div className="flex flex-col ">
                            <button className={`${ordem === 'Processos Crescente' && "border rounded-md border-primary"} `} onClick={() => ordenacao('Processos', 'Crescente')}><ChevronUp size={16} /></button>

                            <button className={`${ordem === 'Processos Decrescente' && "border rounded-md border-primary"}`} onClick={() => ordenacao('Processos', 'Decrescente')}><ChevronDown size={16} /></button>
                          </div>
                        </div>
                      </th>
                      <th className="w-[20%] border p-2 text-left">

                        <div className="flex items-center justify-between">
                          <p>Nome vendedor</p>
                          <div className="flex flex-col ">
                            <button className={`${ordem === 'Nome Vendedor Crescente' && "border rounded-md border-primary"} `} onClick={() => ordenacao('Nome Vendedor', 'Crescente')}><ChevronUp size={16} /></button>

                            <button className={`${ordem === 'Nome Vendedor Decrescente' && "border rounded-md border-primary"}`} onClick={() => ordenacao('Nome Vendedor', 'Decrescente')}><ChevronDown size={16} /></button>
                          </div>
                        </div>
                      </th>
                      <th className="w-[9%] border p-2">
                        <div className="flex items-center justify-between">
                          <p>Dias em atraso</p>
                          <div className="flex flex-col ">
                            <button className={`${ordem === 'Atraso Crescente' && "border rounded-md border-primary"} `} onClick={() => ordenacao('Atraso', 'Crescente')}><ChevronUp size={16} /></button>

                            <button className={`${ordem === 'Atraso Decrescente' && "border rounded-md border-primary"}`} onClick={() => ordenacao('Atraso', 'Decrescente')}><ChevronDown size={16} /></button>
                          </div>
                        </div>

                      </th>
                      <th className="w-[10%] border p-2 text-right">
                        <div className="flex items-center justify-between">
                          <p>Valor vencido</p>
                          <div className="flex flex-col ">
                            <button className={`${ordem === 'Valor Crescente' && "border rounded-md border-primary"} `} onClick={() => ordenacao('Valor', 'Crescente')}><ChevronUp size={16} /></button>

                            <button className={`${ordem === 'Valor Decrescente' && "border rounded-md border-primary"}`} onClick={() => ordenacao('Valor', 'Decrescente')}><ChevronDown size={16} /></button>
                          </div>
                        </div>

                      </th>
                      <th className="w-[8%] border p-2 text-left">
                        Assessoria
                      </th>
                      <th className="w-[13%] border p-2 text-left">
                        <div className="flex items-center justify-between">
                          <p> Último acionamento</p>

                          <div className="flex flex-col ">
                            <button className={`${ordem === 'Acionamento Crescente' && "border rounded-md border-primary"} `} onClick={() => ordenacao('Acionamento', 'Crescente')}><ChevronUp size={16} /></button>

                            <button className={`${ordem === 'Acionamento Decrescente' && "border rounded-md border-primary"}`} onClick={() => ordenacao('Acionamento', 'Decrescente')}><ChevronDown size={16} /></button>
                          </div>
                        </div>
                      </th>
                      <th className="w-[10%] border p-2 text-left">
                        <div className="flex items-center justify-between">
                          <p>Agendamento</p>

                          <div className="flex flex-col ">
                            <button className={`${ordem === 'Agendamento Crescente' && "border rounded-md border-primary"} `} onClick={() => ordenacao('Agendamento', 'Crescente')}><ChevronUp size={16} /></button>

                            <button className={`${ordem === 'Agendamento Decrescente' && "border rounded-md border-primary"}`} onClick={() => ordenacao('Agendamento', 'Decrescente')}><ChevronDown size={16} /></button>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tabelaData
                      ?.filter((dat) =>
                        dat.nome_cliente
                          .toLocaleLowerCase()
                          .includes(filterName.toLocaleLowerCase())
                      )
                      .map((data) => (
                        <tr
                          className={`min-h-[2rem] cursor-pointer ${Number(devedor.id_debtor) === data.id_lista_loja
                            ? "bg-blue-50"
                            : ""
                            }`}
                          key={data.id_lista_loja}
                          onClick={() =>
                            handleDoubleClick(data.cpf_cnpj, data.id_lista_loja)
                          }
                        >
                          <td className="border p-2 pointer-events-none">
                            {data.cpf_cnpj.replace(
                              /(\d{3})(\d{3})(\d{3})(\d{2})/,
                              "$1.$2.$3-$4"
                            )}
                          </td>
                          <td className="border p-2">{data.nome_cliente}</td>
                          <td className="border p-2">{data.id_processo}</td>
                          <td className="border p-2">
                            {data.nome_vendedor ? data.nome_vendedor : "-"}
                          </td>
                          <td className="border p-2 text-right">
                            {data.atraso}
                          </td>
                          <td className="border p-2 text-right">
                            {data.valor_vencido}
                          </td>
                          <td className="border p-2">
                            {data.assessoria ? data.assessoria : "-"}
                          </td>
                          <td className={`border p-2 ${isToday(new Date(formatDate(data.data_ultimo_acionamento))) && 'text-green-600 font-semibold'}`}>
                            {data.data_ultimo_acionamento}
                          </td>
                          <td className={`border p-2 ${(isToday(new Date(formatDate(data.data_agendamento))) || isAfter(new Date(formatDate(data.data_agendamento)), new Date())) && 'text-green-600 font-semibold'}`}>
                            {data.data_agendamento}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              {/* <div className="mt-4 flex w-[20%] items-center justify-between">
                <button
                  className={`rounded-md bg-primary p-2 text-white ${page === 1 ? "cursor-not-allowed opacity-60 " : ""
                    } `}
                  onClick={handlePrevPage}
                  disabled={page === 1}
                >
                  Anterior
                </button>
                <span>Página {page}</span>
                <button
                  className={`rounded-md bg-primary p-2 text-white ${data.data.length < 99
                    ? "cursor-not-allowed opacity-60 "
                    : ""
                    } `}
                  disabled={data.data.length < 99}
                  onClick={handleNextPage}
                >
                  Próxima
                </button>
              </div> */}
            </div>
          )}
        </>
      )}
    </div>
  );
}
